import { BaseSyntheticEvent, useContext, useEffect } from "react";
import {
  BsChevronDoubleDown,
  BsChevronDoubleUp,
  BsChevronLeft,
} from "react-icons/bs";
import { IoBusiness } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import ModeButton from "../../../../components/ModeButton";
import { AuthContext } from "../../../../contexts/Authentication/AuthContext";
import Title from "../Title";
import "../styles.css";
import TooltipConfig from "../../../../components/Tooltip";
import Logout from "../../../Home/Profile";

export default function HeaderDetails(props: {
  onClick?: () => void;
  isOpen: boolean;
  isVisible: boolean;
}) {
  const navigate = useNavigate();
  const { isAuthenticated, user, account } = useContext(AuthContext);
  const { shortToken, mode } = useParams();

  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }

  // useEffect(() => {
  //   console.log(mode)
  // },[mode])

  return props.isVisible ? (
    <>
      {props.isOpen ? (
        <div
          onMouseOver={MouseOver}
          onClick={() => navigate(`/`)}
          className="col-12 col-md-4 d-flex justify-content-center 
            justify-content-md-start align-items-center px-2 py-1 py-md-0"
        >
          <IoBusiness size={30} />
          <h4 className="px-2">Torre Logística de Entregas</h4>
        </div>
      ) : (
        <></>
      )}
      <div
        className={`col-12 py-2 py-md-0 d-flex justify-content-center align-items-center text-center
      ${mode === "edit" ||  props.isOpen ? " col-md-4" : "text-md-start justify-content-md-start col-md-10"}`}
      >
        <Title />
      </div>
      <div
        className={`col-12  d-flex justify-content-center 
        justify-content-md-end align-items-center py-1 py-md-0
        ${mode === "edit" ||  props.isOpen ? "col-md-4" : "justify-content-md-start col-md-2"}`}
      >
        {isAuthenticated || shortToken?.slice(0, 3) !== "ctl" ? (
          <>
            {props.isOpen ? (
              <div className="info_username_right">
                {account}
                <div>{user}</div>
              </div>
            ) : (
              <></>
            )}
            <Logout />
          </>
        ) : (
          <></>
        )}
        <div className="ml-1">
          <ModeButton />
        </div>
        <div className="ml-1">
          <TooltipConfig
            content={["Voltar à tela Minhas Páginas"]}
            children={
              <div
                style={{ border: "0", backgroundColor: "transparent" }}
                onClick={() => {
                  navigate(`/`);
                }}
              >
                <BsChevronLeft />
              </div>
            }
            placement={"bottom"}
            style={true}
          />
        </div>
        {props.onClick !== undefined ? (
          <div
            className="dropdown_button"
            onMouseOver={MouseOver}
            onClick={() => {
              props.onClick !== undefined ? props.onClick() : "";
            }}
          >
            <TooltipConfig
              content={props.isOpen ? ["Esconder menu"] : ["Mostrar menu"]}
              children={
                props.isOpen ? <BsChevronDoubleUp /> : <BsChevronDoubleDown />
              }
              placement={"bottom"}
              style={true}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  ) : (
    <></>
  );
}
